var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4F46E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_3581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 23.0003H20.0833V20.0586C20.0829 19.6012 19.901 19.1628 19.5776 18.8394C19.2542 18.516 18.8158 18.3341 18.3584 18.3337H13.6416C13.1842 18.3341 12.7458 18.516 12.4224 18.8394C12.099 19.1628 11.9171 19.6012 11.9167 20.0586V23.0003H10.75V20.0586C10.7509 19.292 11.0559 18.557 11.5979 18.0149C12.14 17.4729 12.875 17.1679 13.6416 17.167H18.3584C19.125 17.1679 19.86 17.4729 20.4021 18.0149C20.9441 18.557 21.2491 19.292 21.25 20.0586V23.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C15.3078 16 14.6311 15.7947 14.0555 15.4101C13.4799 15.0256 13.0313 14.4789 12.7664 13.8394C12.5015 13.1999 12.4322 12.4961 12.5673 11.8172C12.7023 11.1383 13.0356 10.5146 13.5251 10.0251C14.0146 9.53564 14.6383 9.2023 15.3172 9.06725C15.9961 8.9322 16.6999 9.00152 17.3394 9.26642C17.9789 9.53133 18.5256 9.97993 18.9101 10.5555C19.2947 11.1311 19.5 11.8078 19.5 12.5C19.4991 13.428 19.13 14.3177 18.4739 14.9739C17.8177 15.63 16.928 15.9991 16 16V16ZM16 10.1667C15.5385 10.1667 15.0874 10.3035 14.7037 10.5599C14.32 10.8163 14.0209 11.1807 13.8443 11.6071C13.6677 12.0334 13.6215 12.5026 13.7115 12.9552C13.8015 13.4078 14.0238 13.8236 14.3501 14.1499C14.6764 14.4762 15.0922 14.6985 15.5448 14.7885C15.9974 14.8785 16.4666 14.8323 16.8929 14.6557C17.3193 14.4791 17.6837 14.18 17.9401 13.7963C18.1965 13.4126 18.3333 12.9615 18.3333 12.5C18.3333 11.8812 18.0875 11.2877 17.6499 10.8501C17.2123 10.4125 16.6188 10.1667 16 10.1667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_3581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.3b59de931db0aee1cd21985f40671232.svg";
export { ForwardRef as ReactComponent };